import { Pipe, PipeTransform } from "@angular/core";
import { Link } from "../models/model";

@Pipe({ name: "campaignUrlPipe", standalone: true })
export class CampaignUrlPipe implements PipeTransform {
  transform(campaign: Link, mainDomain: string): string {
    switch (campaign?.type) {
      case "business": return mainDomain + "/bu-" + campaign.id;
      default:         return mainDomain + "/sh-" + campaign.id;
    }
  }
}
import { PromoListsService } from "../services/promoList.service";

@Pipe({ name: "linkTransformPipe", standalone: false })
export class LinkTransformPipe implements PipeTransform {
  transform(links: any[], setNames: (data: any) => string): Link[] {
    return links.map((data) => {
      const newLink: Link = {
        id: data.id,
        business_id: data.business_id,
        url: data?.url || data?.URL,
        paid_comissions: data.paid_comissions,
        certification_settings: data.certification_settings,
        clicks: data.clicks,
        created_at: data.created_at,
        enroll: data.enroll,
        last_activity: data.last_activity,
        last_update: data.last_update,
        offer_data: data.offer_data,
        offer_id: data.offer_id,
        plus_price: data.plus_price,
        price: data.product?.price || data.price_course || "0",
        product_id: parseInt(data.product_id),
        registered: data.registered,
        state: data.state,
        paid: data.paid || "0",
        status_last_update: data.status_last_update,
        total_profit: parseFloat(Number(data.total_profit).toFixed(2)),
        type: data.type,
        user_id: data.user_id,
        name: setNames(data),
        isDerivedName: !data.name,
        mediaContent: {
          id: data.product_id,
          type: data.type,
          media: data.product?.media,
          image_web: data.product?.image_web ?? data.product?.media,
        },
        discount: data?.discount
      };

      return newLink;
    });
  }
}

@Pipe({
  name: "inAffiliatesPipe",
  standalone: false
})
export class InAffiliatesPipe implements PipeTransform {
  transform(url: string): boolean {
    return url.includes("afiliados");
  }
}

@Pipe({
  name: "calculateBenefitPipe",standalone: false
})
export class calculateBenefitPipe implements PipeTransform {
  transform(price: number, benefit: number, discount: number): any {
    let benefitTotal = 0;
    if (benefit === 0) {
      benefitTotal = price * ((100 - discount) / 100) * 0.1;
    } else {
      benefitTotal = price * (benefit / 100) * ((100 - discount) / 100);
    }
    return "$" + benefitTotal.toFixed(2);
  }
}

@Pipe({
  name: "calculatePricePipe",
  standalone: true,
})
export class CalculatePricePipe implements PipeTransform {
  transform(price: number, benefit: number, discount: number = 0): any {
    // Aplicar descuento y agregar beneficio
    if (discount) {
      if (discount.toString().includes("%")) {
        discount = parseInt(discount.toString().replace("%", ""));
      }
    }
    const discountedPrice = price - price * (discount / 100);
    const benefitPrice = price * (benefit / 100);
    const finalPrice = discountedPrice + benefitPrice;
    return finalPrice;
  }
}

@Pipe({ name: "secondsToHoursPipe",standalone: false })
export class SecondsToHoursPipe implements PipeTransform {
  transform(seconds: number): number {
    var horas = Math.floor(seconds / 3600);
    return horas;
  }
}

@Pipe({ name: "hoursToSecondsPipe",standalone: false })
export class HoursToSecondsPipe implements PipeTransform {
  transform(hours: number): number {
    var seconds = hours * 3600;
    return seconds;
  }
}

@Pipe({
  name: "checkLinkPipe",standalone: false
})
export class CheckLinkPipe implements PipeTransform {
  transform(link: any, links: any[]): boolean {
    if (!links || links.length === 0) {
      return false;
    }

    return links.some((item) => {
      return item.id === link.id;
    });
  }
}

let websiteUrl = {
  "1": "https://d3puay5pkxu9s4.cloudfront.net/img/landin-covers/home.jpg",
  "2": "https://d3puay5pkxu9s4.cloudfront.net/img/landin-covers/about-us.jpg",
  "3": "https://d3puay5pkxu9s4.cloudfront.net/img/landin-covers/campus.jpg",
  "4": "https://d3puay5pkxu9s4.cloudfront.net/img/landin-covers/creative-commons.jpg",
  "5": "https://d3puay5pkxu9s4.cloudfront.net/img/landin-covers/help.jpg",
  "6": "https://d3puay5pkxu9s4.cloudfront.net/img/landin-covers/history.jpg",
};
@Pipe({ name: "getWebsiteUrl", standalone: true })
export class GetWebsiteUrlPipe implements PipeTransform {
  transform(product_id: any): string {
    product_id = product_id.toString();
    let campaing = websiteUrl[product_id];
    if (campaing) {
      return campaing;
    }
  }
}
